Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    mastheadMobileShadowOffsetX: 0,
    mastheadMobileShadowOffsetY: 2,
    mastheadMobileShadowBlur: 4,
    mastheadMobileShadowSpread: 0,
    mastheadMobileShadowColor: "#02080E",
    mastheadMobileShadowOpacity: 16,
    mastheadBackgroundColorSurface: tokens.themeSurfaceDefault,
    mastheadBackgroundColorPrincipal: tokens.themePageDefault,
    mastheadBackgroundColorHighlight: tokens.themePageHighlight,
    mastheadBackgroundColorSubdued: tokens.themePageSubdued,
    mastheadShadowOffsetX: 0,
    mastheadShadowOffsetY: 4,
    mastheadShadowBlur: 8,
    mastheadShadowSpread: 0,
    mastheadShadowColor: "#02080E",
    mastheadShadowOpacity: 16,
    mastheadElevation: 30,
    mastheadSpacingHorizontal: 16,
    mastheadMenuButtonWidth: 32,
    mastheadMenuButtonMotionDuration: "300ms",
    mastheadMenuButtonMotionFunction: "ease",
    mastheadSizeSmall: 36,
    mastheadSizeMedium: 48,
    mastheadSizeLarge: 56,
    mastheadLinkMotionDuration: "100ms",
    mastheadLinkMotionFunction: "ease",
    mastheadLinkSpacingInsetHorizontal: 16,
    mastheadLinkForegroundColorDefault: tokens.themeInkDefault,
    mastheadLinkForegroundColorDisabled: tokens.themeInkDisabled,
    mastheadLinkBackgroundColorHover: tokens.themeActionNeutralHover,
    mastheadLinkBackgroundColorPressed: tokens.themeActionNeutralPressed,
    mastheadLinkIndicatorColor: tokens.themeDecorativePaletteDefault,
    mastheadLinkIndicatorHeight: 4,
    mastheadLinkIndicatorSpacingHorizontal: 4,
    mastheadLinkIndicatorSpacingVerticalDefault: 4,
    mastheadLinkIndicatorSpacingVerticalSmall: 0,
    mastheadLinkIndicatorBorderRadius: 999,
    mastheadActionsSpacing: 8,
    mastheadActionsSpacingInsetHorizontal: 16,
    mastheadActionsSpacingInsetVerticalSmall: 0,
    mastheadActionsSpacingInsetVerticalMedium: 8,
    mastheadActionsSpacingInsetVerticalLarge: 8,
    mastheadTitleSpacingInsetVertical: 8,
    mastheadBorderWidth: 1,
    mastheadBorderRadius: 0,
    mastheadBorderColor: tokens.themeBorderSurface
  }
};